<h6 class="bxt-table-title" *ngIf="contact && contact.ContactCards">
    {{ title }} <span *ngIf="contact.ContactCards.length">({{ contact.ContactCards.length }})</span>
</h6>
<div class="header" *ngIf="contact && contact.ContactCards">
    <presets-dropdown
        presetType="contactcards"
        (contentChange)="applyPreset($event)"
        [content]="contactCardsForPresets"
        class="pull-right margin-bottom-10">
    </presets-dropdown>
    <div class="new">
        <button class="btn-bx-primary" (click)="addCard()">Create New</button>
    </div>
</div>
<div class="panel panel-white">
    <div class="panel-body" style="background-color: #f9f9f9">
        <div
            class="col-xs-12 text-center"
            *ngIf="contact.ContactCards.length == 0 && permissionService.isAvailable('contacts.maintain-cards.add-card')">
            <h4 class="margin-top-30">
                Use cards to keep track of certificates, insurances, licenses and other important records for this contact.
            </h4>
            <h2 class="margin-top-10 margin-bottom-30"><a (click)="addCard()">Add cards</a> for this contact</h2>
        </div>

        <div class="row">
            <div *ngFor="let card of contact.ContactCards; let i = index">
                <div class="clearfix" *ngIf="i % 2 == 0"></div>
                <div class="col-sm-6">
                    <div class="panel panel-white">
                        <div class="panel-heading border-light">
                            <h4 class="panel-title margin-bottom-10 text-bold">
                                {{ card.CardName }}
                                <button
                                    type="button"
                                    class="pull-right btn btn-danger btn-xs"
                                    (click)="deleteCard($event, card)"
                                    uib-tooltip="Delete card">
                                    <i class="ti-trash"></i>
                                </button>
                            </h4>
                            <h5>
                                <i class="ti-ticket"></i>
                                {{ card.CardType }}
                            </h5>
                        </div>
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-xs-12">
                                    <div class="pull-left">
                                        <p *ngIf="card.Expiry">
                                            <span
                                                class="label"
                                                [ngClass]="{
                                                    'label-danger': card.CardStatus === 'Expired',
                                                    'label-warning': card.CardStatus === 'Expiring',
                                                    'label-success': card.CardStatus === 'Valid',
                                                }"
                                                >Expiry {{ card.Expiry | date: 'mediumDate' }}</span
                                            >
                                        </p>
                                        <p *ngIf="!card.Expiry">No Expiry</p>
                                    </div>
                                    <div class="pull-right">
                                        <button type="button" class="btn btn-info" (click)="viewCard(card)" uib-tooltip="Edit this card">
                                            <i class="ti-pencil"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="margin-top-10 text-normal" [hidden]="!card.CardDetails">
                                <pre class="wrappable-pre max-height-120">{{ card.CardDetails }}</pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
